// src/components/payments/PayPalCheckout.tsx
import React from 'react';
import { PayPalScriptProvider, PayPalButtons } from '@paypal/react-paypal-js';
import { captureOrder, confirmSubscription } from '../../api/paymentsApi';
// createWeeklyOrder, ^
interface PayPalCheckoutProps {
  type: 'one-time' | 'subscription';
  amount?: string;
  planIdOverride?: string;
}

const PayPalCheckout: React.FC<PayPalCheckoutProps> = ({ type, amount = '4.00', planIdOverride }) => {
  const clientId = process.env.REACT_APP_PAYPAL_CLIENT_ID!;
  const defaultPlanId = process.env.REACT_APP_PAYPAL_PLAN_ID!;
  const planId = planIdOverride || defaultPlanId;

  const handleApprove = async (data: any) => {
    if (type === 'one-time') {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { data: result, error } = await captureOrder(data.orderID);
      if (error) {
        alert(`Failed to capture payment: ${error}`);
        return;
      }
      alert('Access granted for 7 days!');
      window.location.reload();
    } else if (data.subscriptionID) {
      const { error } = await confirmSubscription(data.subscriptionID);
      if (error) {
        alert(`Failed to confirm subscription: ${error}`);
        return;
      }
      alert('Subscription activated!');
      window.location.reload();
    }
  };

  const buttonStyle = {
    layout: 'vertical' as const,
    shape: 'pill' as const,
    color: 'white' as const,
    label: type === 'subscription' ? 'subscribe' as const : 'pay' as const,
  };

  const providerOptions =
    type === 'subscription'
      ? { clientId, intent: 'subscription', vault: true }
      : { clientId, intent: 'capture' };

  return (
    <PayPalScriptProvider options={providerOptions}>
{/*       {type === 'one-time' ? (
        <PayPalButtons
          style={buttonStyle}
          createOrder={async () => {
            const { data, error } = await createWeeklyOrder(amount);
            if (error || !data?.id) {
              alert(`Failed to create order: ${error || 'No order id returned'}`);
              throw new Error(error || 'No order id');
            }
            return data.id;
          }}
          onApprove={handleApprove}
        />
      ) : ( */}
        <PayPalButtons
          style={buttonStyle}
          createSubscription={(data, actions) => {
            return actions.subscription.create({
              plan_id: planId,
            });
          }}
          onApprove={handleApprove}
        />
{/*       )} */}
    </PayPalScriptProvider>
  );
};

export default PayPalCheckout;

